// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","691":"component---src-pages-index-tsx","893":"component---src-pages-compartilhar-index-tsx"}[chunkId] || chunkId) + "-" + {"351":"a6184bfb7896db1cae61","691":"78386f8e8ad603d72f2b","731":"ce3ae39cefeed8e6301b","843":"06d6f8d9320b8f2ae170","893":"b16164abf06a853b7ea5"}[chunkId] + ".js";
};